import { z } from 'zod'

// The shapes stay nullable so the extraction can prefill whatever it found. The VAT amount is no
// field: it is always calculated from the amount and the VAT rate.
export const importedInvoiceReviewLineSchema = z.object({
  amountExclVat: z.number().nullable(),
  categoryId: z.string().nullable(),
  description: z.string(),
  vatRateId: z.string().nullable(),
})

export const importedInvoiceReviewFormShapeSchema = z.object({
  client: z.object({ id: z.string().optional(), name: z.string().optional() }).nullable(),
  currency: z.string().nullable(),
  dueDate: z.date().nullable(),
  issueDate: z.date().nullable(),
  lines: z.array(importedInvoiceReviewLineSchema),
  referenceNumber: z.string(),
})

export type ImportedInvoiceReviewFormSchema = typeof importedInvoiceReviewFormShapeSchema
export type ImportedInvoiceReviewFormValues = z.infer<typeof importedInvoiceReviewFormShapeSchema>
export type ImportedInvoiceReviewLineValues = z.infer<typeof importedInvoiceReviewLineSchema>
